import styled, {css} from 'styled-components';
import {tabletAndUp} from '../../../constants/customMedia';
import {UnstyledLink} from '../../atoms/UnstyledLink/UnstyledLink';

export const HeaderLink = styled(UnstyledLink)`
  margin-inline-end: 16px;
  justify-content: flex-end;
  display: flex;
  align-items: center;

  width: auto;
  ${tabletAndUp(css`
    width: 100%;
  `)}
`;
